import React from 'react';

import Link from '@/components/Link';

interface ProjectChipProps {
  name: string;
  to?: string;
}

export function ProjectChip({ name, to }: ProjectChipProps): React.ReactNode {
  const chip = (
    <span className="inline-flex items-center whitespace-nowrap rounded bg-surface-secondary px-6 py-1 text-[1.1rem] font-medium text-on-surface-secondary">
      {name}
    </span>
  );

  if (to) {
    return (
      <Link to={to} className="no-underline">
        {chip}
      </Link>
    );
  }

  return chip;
}
